module.exports = __webpack_public_path__ + "static/media/Blake Coles Bat.230e4a51.jpg";